import Image from 'next/image'
import Link from 'next/link'
import styles from './style.module.scss'

type Props = {
  // children: ReactNode
  src: string
  to: string
  art?: string
  blank?: boolean
}

const SideImageBanner: React.VFC<Props> = ({ src, art, to, blank }) => {
  return (
    <div className={styles.sideImageBanner}>
      {!blank ? (
        <Link href={to}>
          <a>
            <Image
              src={src}
              layout="responsive"
              width={300}
              height={300}
              alt={art}
            />
          </a>
        </Link>
      ) : (
        <Link href={to} passHref>
          <a target="_blank" rel="noreferrer noopener">
            <Image
              src={src}
              layout="responsive"
              width={300}
              height={300}
              alt={art}
            />
          </a>
        </Link>
      )}
    </div>
  )
}

export { SideImageBanner }
